export default class Order{
    constructor(type_service=['site','site'],home={price:0,collect:{direction:'',reference:'',location:[],datetime:{date:null,time:null,datetime:null}},delivery:{direction:'',reference:'',location:[],datetime:{date:null,time:null,datetime:null}}}){
        this.type_service=type_service
        this.home=home
    }
}